<template>
  <div class="button-logo">
    <button
      ref="navBtn"
      type="button"
      class="button-logo__button"
      aria-haspopup="menu"
      :aria-controls="isOpen ? 'login-nav-menu-wrapper' : null"
      :is-loading="isLoading"
      :aria-label="ariaLabelLoginButton"
      :class="isConnected ? 'button-logo__button--connected' : 'button-logo__button--disconnected'"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="sendClick"
    >
      <IconComponent
        v-if="!isLoading"
        :alt="isConnected ? 'account-connected-24-alt' : 'account-24-alt'"
      >
        <component
          :is="componentIs"
          :is-connected="isConnected"
        />
      </IconComponent>
      <span
        v-else
        class="loading loading--default"
      >
        <span class="sr-only">Loading...</span>
        <svg
          viewBox="0 0 70 70"
          aria-hidden="true"
          focusable="false"
        >
          <circle
            cx="35"
            cy="35"
            r="29"
          />
        </svg>
      </span>
      <span
        class="button-logo__text"
        :class="isConnected ? 'button-logo__text--connected' : 'button-logo__text--disconnected'"
      >
        {{ navButtonLabel }}
      </span>
    </button>
  </div>
</template>

<script src="./NavButton.es"></script>
<style lang="scss" src="./NavButton.scss" scoped></style>
